import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useTranslation } from 'react-i18next';

function ViewHistoryModal({ visible, setVisible, history }) {
  const { t } = useTranslation();

  const formatDeadline = (rowData) => (
    <div className="text-center">{new Date(rowData.deadline).toLocaleDateString()}</div>
  );
  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('employee.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
    </div>
  );
  return (
    <Dialog
      header={<p className="text-blue-500">{t('submitDocument.history')}</p>}
      visible={visible}
      position="center"
      style={{ width: '800px', maxHeight: '800px' }}
      className="p-dialog-scroll"
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <DataTable value={history} showGridlines>
        <Column
          field="createdAt"
          body={formatDeadline}
          header={t('submitDocument.deadline')}
          style={{ width: '20%' }}
        />
        <Column
          field="comment"
          header={t('submitDocument.comment')}
          className="text-center"
          style={{ width: '40%' }}
        />
        <Column
          field="feedback"
          header={t('submitDocument.feedback')}
          className="text-center"
          style={{ width: '40%' }}
        />
      </DataTable>
    </Dialog>
  );
}

ViewHistoryModal.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.array,
};

ViewHistoryModal.defaultProps = {
  visible: false,
  setVisible: () => {},
  history: [],
};

export default ViewHistoryModal;
